(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-description"]) return;
  try {
    
  if (!window.__ttPdpMetaMobileBound) {
    window.__ttPdpMetaMobileBound = true;
    const MQ = '(max-width: 749px)';

    const nodes = () => ({
      meta: document.querySelector('[data-tt-pdp-meta]'),
      home: document.querySelector('[data-tt-pdp-meta-home]')
    });

    const buyAnchor = () => {
      const root = document.querySelector('.section-main-product .product-info') || document.querySelector('product-info');
      if (!root) return null;
      const quote = root.querySelector(
        '[data-tt-add-to-quote], .tt-add-to-quote, [data-tt-quote-button], [data-tread-quote-button], [data-tread-add-to-quote]'
      );
      if (quote) {
        return (
          quote.closest('.product-form-buttons') ||
          quote.closest('.product-info-buy-buttons') ||
          quote.closest('.tread-buy-block__form') ||
          quote.closest('.tread-buy-block') ||
          quote
        );
      }
      return root.querySelector('.product-info-buy-buttons, .tread-buy-block__form, .tread-buy-block');
    };

    const mobileWrap = () => document.querySelector('[data-tt-pdp-meta-mobile-wrap]');

    const ensureWrap = (anchor) => {
      let wrap = mobileWrap();
      if (wrap) {
        if (wrap.previousElementSibling !== anchor) anchor.insertAdjacentElement('afterend', wrap);
        return wrap;
      }
      wrap = document.createElement('div');
      wrap.className = 'tt-pdp-meta-mobile product-description isolate';
      wrap.setAttribute('data-tt-pdp-meta-mobile-wrap', '');
      wrap.innerHTML = '<div class="product-description__wrapper product-description__wrapper--mobile-slot"></div>';
      anchor.insertAdjacentElement('afterend', wrap);
      return wrap;
    };

    const sync = () => {
      const { meta, home } = nodes();
      if (!meta || !home) return;
      if (window.matchMedia(MQ).matches) {
        const anchor = buyAnchor();
        if (!anchor) return;
        const holder = ensureWrap(anchor).querySelector('.product-description__wrapper');
        if (holder && meta.parentNode !== holder) holder.appendChild(meta);
      } else {
        if (home.nextElementSibling !== meta) home.insertAdjacentElement('afterend', meta);
        const wrap = mobileWrap();
        if (wrap) wrap.remove();
      }
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
    else sync();
    window.matchMedia(MQ).addEventListener('change', sync);
    document.addEventListener('shopify:section:load', sync);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-customer-proof"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var button = event.target.closest('[data-tt-proof-scroll]');

    if (!button) {
      return;
    }

    var wall = button.closest('.tt-customer-proof__snapshot--wall');
    var scroller = wall && wall.querySelector('.tt-customer-proof__wall-scroll');

    if (!scroller) {
      return;
    }

    var increment = Math.max(280, scroller.clientHeight * 0.7);
    var maxScroll = scroller.scrollHeight - scroller.clientHeight;
    var nextScroll = scroller.scrollTop + increment;

    if (nextScroll >= maxScroll - 8) {
      nextScroll = 0;
    }

    scroller.scrollTo({
      top: nextScroll,
      behavior: 'smooth'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tt-machine-fitment-hub"] && !Shopify.designMode) return;
  try {
    
  if (!window.__ttHubRowCart) {
    window.__ttHubRowCart = true;
    document.addEventListener('click', function (event) {
      var btn = event.target.closest && event.target.closest('[data-tt-hub-add-cart]');
      if (!btn) return;
      event.preventDefault();
      if (btn.getAttribute('data-available') !== 'true') return;
      var id = btn.getAttribute('data-variant-id');
      if (!id) return;
      var payload = { id: id, quantity: 1 };
      var equipment = btn.getAttribute('data-tt-equipment');
      if (equipment) {
        payload.properties = { equipment: equipment };
      }
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add_failed');
          return res.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (window.theme && typeof window.theme.openCart === 'function') {
            window.theme.openCart();
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function () {
          btn.disabled = false;
        })
        .finally(function () {
          btn.disabled = false;
        });
    });
  }

  if (!window.__ttHubStickyBuy) {
    window.__ttHubStickyBuy = true;
    const bindHubStickyBuy = (root) => {
      const bar = root.querySelector('[data-tt-hub-sticky-buy]');
      if (!bar) return;
      const label = bar.querySelector('[data-tt-hub-sticky-label]');
      const atc = bar.querySelector('[data-tt-hub-sticky-atc]');
      const quote = bar.querySelector('[data-tt-hub-sticky-quote]');
      const copyAttrs = ['data-variant-id', 'data-available', 'data-tt-equipment', 'data-tt-canonical-sku', 'data-tt-itemid'];

      const rowActionsVisible = (row) => {
        const buy = row.querySelector('.tt-machine-part-row__buy');
        if (!buy) return false;
        const box = buy.getBoundingClientRect();
        const viewHeight = window.innerHeight || 0;
        return box.bottom > 88 && box.top < viewHeight - 24;
      };

      const bindFrom = (row) => {
        const title = row.querySelector('.tt-machine-part-row__title');
        const price = row.querySelector('.tt-machine-part-row__price strong');
        const srcAtc = row.querySelector('[data-tt-hub-add-cart]');
        const srcQuote = row.querySelector('[data-tt-add-to-quote]');
        const parts = [];
        if (title && title.textContent) parts.push(title.textContent.trim());
        if (price && price.textContent) parts.push(price.textContent.trim());
        if (label) label.textContent = parts.join(' · ');

        if (srcAtc && atc) {
          atc.hidden = false;
          copyAttrs.forEach((attr) => {
            const value = srcAtc.getAttribute(attr);
            if (value) atc.setAttribute(attr, value);
            else atc.removeAttribute(attr);
          });
        } else if (atc) {
          atc.hidden = true;
          copyAttrs.forEach((attr) => atc.removeAttribute(attr));
        }

        if (srcQuote && quote) {
          quote.hidden = false;
          quote.href = srcQuote.getAttribute('href') || '/pages/request-a-quote';
          const variantId = srcQuote.getAttribute('data-variant-id');
          if (variantId) quote.setAttribute('data-variant-id', variantId);
          else quote.removeAttribute('data-variant-id');
        } else if (quote) {
          quote.hidden = true;
        }
      };

      const pickRow = () => {
        const viewHeight = window.innerHeight || 1;
        const focus = viewHeight * 0.4;
        let best = null;
        let bestDist = Infinity;
        root.querySelectorAll('.tt-machine-part-row').forEach((row) => {
          if (row.closest('[hidden]')) return;
          const box = row.getBoundingClientRect();
          if (box.bottom < 80 || box.top > viewHeight) return;
          const mid = (box.top + box.bottom) / 2;
          const dist = Math.abs(mid - focus);
          if (dist < bestDist) {
            bestDist = dist;
            best = row;
          }
        });
        return best;
      };

      const update = () => {
        const row = pickRow();
        if (!row) {
          bar.hidden = true;
          root.classList.remove('tt-machine-parts--sticky-buy');
          return;
        }
        bindFrom(row);
        const show = !rowActionsVisible(row);
        bar.hidden = !show;
        root.classList.toggle('tt-machine-parts--sticky-buy', show);
      };

      let ticking = false;
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          update();
        });
      };

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      root.addEventListener('click', (event) => {
        if (event.target.closest('[data-tt-part-target]')) onScroll();
      });
      root.__ttHubStickyBuyUpdate = update;
      update();
    };

    document.querySelectorAll('.tt-machine-parts').forEach(bindHubStickyBuy);
  }

  const switchMachinePartGroup = (trigger) => {
    const section = trigger.closest('.tt-machine-parts');
    if (!section) return;

    const target = trigger.getAttribute('data-tt-part-target');
    if (!target) return;

    section.querySelectorAll('[data-tt-part-panel]').forEach((panel) => {
      const isActive = panel.getAttribute('data-tt-part-panel') === target;
      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);
    });

    section.querySelectorAll('[data-tt-part-target]').forEach((tab) => {
      const isActive = tab.getAttribute('data-tt-part-target') === target;
      tab.classList.toggle('tt-machine-parts__summary-button--active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.tabIndex = isActive ? 0 : -1;
    });

    if (typeof section.__ttHubStickyBuyUpdate === 'function') {
      section.__ttHubStickyBuyUpdate();
    }
  };

  const syncIntroToggle = (wrap) => {
    const text = wrap.querySelector('[data-tt-intro-text]');
    const toggle = wrap.querySelector('[data-tt-intro-toggle]');
    if (!text || !toggle) return;

    const expanded = wrap.classList.contains('is-expanded');
    text.classList.add('tt-machine-parts__intro--clamped');
    wrap.classList.remove('is-expanded');

    const overflows = text.scrollHeight > text.clientHeight + 1;

    if (!overflows) {
      text.classList.remove('tt-machine-parts__intro--clamped');
      toggle.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = 'Read more';
      return;
    }

    toggle.hidden = false;

    if (expanded) {
      wrap.classList.add('is-expanded');
      text.classList.remove('tt-machine-parts__intro--clamped');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.textContent = 'Show less';
    } else {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = 'Read more';
    }
  };

  const initIntroToggles = () => {
    document.querySelectorAll('[data-tt-intro]').forEach((wrap) => syncIntroToggle(wrap));
  };

  document.addEventListener('click', (event) => {
    const introToggle = event.target instanceof Element ? event.target.closest('[data-tt-intro-toggle]') : null;
    if (introToggle) {
      const wrap = introToggle.closest('[data-tt-intro]');
      if (!wrap) return;
      event.preventDefault();
      wrap.classList.toggle('is-expanded');
      syncIntroToggle(wrap);
      return;
    }

    const trigger = event.target instanceof Element ? event.target.closest('[data-tt-part-target]') : null;
    if (!trigger) return;

    event.preventDefault();
    switchMachinePartGroup(trigger);
  });

  document.addEventListener('keydown', (event) => {
    const trigger = event.target instanceof Element ? event.target.closest('[data-tt-part-target]') : null;
    if (!trigger) return;

    const tabs = Array.from(trigger.closest('.tt-machine-parts__summary').querySelectorAll('[data-tt-part-target]'));
    const index = tabs.indexOf(trigger);
    let nextIndex = index;

    if (event.key === 'ArrowRight') nextIndex = index + 1;
    if (event.key === 'ArrowLeft') nextIndex = index - 1;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = tabs.length - 1;

    if (nextIndex === index) return;

    event.preventDefault();

    if (nextIndex < 0) nextIndex = tabs.length - 1;
    if (nextIndex >= tabs.length) nextIndex = 0;

    const nextTab = tabs[nextIndex];
    nextTab.focus();
    switchMachinePartGroup(nextTab);
  });

  document.addEventListener('DOMContentLoaded', () => {
    const requested = window.location.hash.replace('#', '');
    document.querySelectorAll('.tt-machine-parts').forEach((section) => {
      const requestedTab = requested ? section.querySelector('[data-tt-part-target="' + requested + '"]') : null;
      const selectedTab = requestedTab || section.querySelector('[data-tt-part-target][aria-selected="true"]') || section.querySelector('[data-tt-part-target]');
      if (selectedTab) switchMachinePartGroup(selectedTab);
    });

    initIntroToggles();
  });

  window.addEventListener('resize', () => {
    window.requestAnimationFrame(initIntroToggles);
  });

  } catch(e) { console.error(e); }
})();
})();
